import { useAction } from "@/hooks/shared";
import { deleteCompanyHandler } from "@/services";

export const useDeleteCompany = () => useAction(deleteCompanyHandler);
